import { useState } from 'react';

const faqs = [
  {
    q: '喵趣漫画网更新频率是怎样的？',
    a: '喵趣漫画网与热门作品保持同步更新，绝大多数连载章节在首发后 24 小时内完成独家汉化翻译上线，抢先看的追更速度位居同类站点前列。',
  },
  {
    q: '这里的内容是未删减高清原版吗？',
    a: '是的。喵趣漫画网主打未删减高清原版内容，保留完整分镜与对白，不做阉割处理，让你看到原汁原味、不缩水的漫画作品。',
  },
  {
    q: '独家翻译和抢先看有什么区别？',
    a: '独家翻译是喵趣漫画网独立完成的汉化版本，抢先看则是比其它站点更早上线的新章节。两者结合，让你第一时间读到最新剧情，既保证质量又保证速度。',
  },
  {
    q: '如何订阅追更提醒？',
    a: '在页面底部填写邮箱即可订阅追更提醒，作品更新后我们会第一时间把新章节动态发送给你，不会再错过任何一次抢先看。',
  },
  {
    q: '追更进度会自动保存吗？',
    a: '会的。收藏的作品与阅读进度都会自动保存并同步，换设备也能接着上次的地方继续看，体验无缝衔接。',
  },
  {
    q: '阅读需要付费吗？',
    a: '大部分连载内容可免费抢先阅读。部分独家高清原版与特典内容会以合理的会员或兑换方式开放，保证高质量汉化的持续产出。',
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[860px] px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-question-line text-primary-500"></i>
            追更答疑
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            关于更新、未删减、独家翻译与追更的疑问，这里都有答案。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, index) => {
            const isOpen = open === index;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-900'
                    }`}
                  >
                    <i className={`ri-add-line text-base transition-transform ${isOpen ? 'rotate-45' : ''}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}